import type { AppState, GetterClass } from '../../../models'

export class FiltersHiddenGetter implements GetterClass {
  static execute(this: void, state: AppState): boolean {
    return state.filtersHidden
  }
}
